import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { useTenantStore, useAuthStore } from '@/stores'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader } from '@/components/ui/card'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { Badge } from '@/components/ui/badge'
import { Identicon } from '@/components/Identicon'
import { PlanString } from '@/stores/TenantStore'
import { RootPlan } from '@core/models'
import TenantDrawer from './TenantDrawer'

const TenantList = observer(() => {
  const tenantStore = useTenantStore()
  const authStore = useAuthStore()
  const navigate = useNavigate()
  const [drawerOpen, setDrawerOpen] = useState(false)

  useEffect(() => {
    tenantStore.getTenants()
  }, [tenantStore])

  const handleViewDetails = (tenantId: string) => {
    navigate(`/tenants/${tenantId}`)
  }

  const handleSwitchTenant = async (tenantId: string) => {
    authStore.startSpoofing(tenantId)
    // 新しいテナント情報を取得してプランを更新
    await tenantStore.getTenant(tenantId)
    navigate('/')
  }

  return (
    <>
      <div className="space-y-6 mb-6">
        <h1 className="text-3xl font-bold">テナント管理</h1>
      </div>
      <Card>
        <CardHeader className="flex flex-row items-center justify-end">
          <Button onClick={() => setDrawerOpen(true)}>
            テナント作成
          </Button>
        </CardHeader>
        <CardContent>
          {tenantStore.nonRootTenants.length === 0 ? (
            <div className="text-center py-12 text-muted-foreground">
              テナントがありません
            </div>
          ) : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead className="w-16"></TableHead>
                  <TableHead>ID</TableHead>
                  <TableHead>名前</TableHead>
                  <TableHead>プラン</TableHead>
                  <TableHead className="text-right">操作</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {tenantStore.nonRootTenants.map((tenant) => (
                  <TableRow key={tenant.id}>
                    <TableCell>
                      <Identicon source={tenant.id} size={32} />
                    </TableCell>
                    <TableCell className="font-mono text-sm">
                      {tenant.id}
                    </TableCell>
                    <TableCell>{tenant.name}</TableCell>
                    <TableCell>
                      <Badge variant={tenant.plan === RootPlan ? 'destructive' : 'secondary'}>
                        {PlanString[tenant.plan] || 'Unknown'}
                      </Badge>
                    </TableCell>
                    <TableCell className="text-right">
                      <div className="flex gap-2 justify-end">
                        {authStore.isRootTenant && !authStore.isSpoofing && (
                          <Button
                            variant="destructive"
                            size="sm"
                            onClick={() => handleSwitchTenant(tenant.id)}
                          >
                            なりすまし管理
                          </Button>
                        )}
                        <Button
                          variant="outline"
                          size="sm"
                          onClick={() => handleViewDetails(tenant.id)}
                        >
                          詳細
                        </Button>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>

      <TenantDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      />
    </>
  )
})

export default TenantList